import React from 'react';
import { CeDealershipV1, DealershipUserV1 } from '../../services/dealerships/types';

interface DealershipInfoProps {
  dealership: CeDealershipV1;
  onDealershipClick?: (dealership: DealershipUserV1) => void;
}

const DealershipInfo: React.FC<DealershipInfoProps> = ({ dealership, onDealershipClick }) => {
  const handleUserSelect = (dealership: CeDealershipV1) => {
    if (onDealershipClick) {
      onDealershipClick(dealership); // Notify parent
    }
    // You can now do something with the selected user
  };
  return (
    <div className="mb-10">
      <h3 className="font-medium text-xl mb-2">Dealership Info</h3>
      <div
        onClick={() => handleUserSelect(dealership)}
        className="flex flex-col center items-stretch border border-black rounded-lg p-4 max-w-md bg-white">
        <div className="flex center text-center font-bold text-xl">{dealership.name}</div>
        <div>Dealership Id: {dealership.id}</div>
      </div>
    </div>
  );
};

export default DealershipInfo;
